const defaultTheme = { typography: { fontFamily: 'Arial' } };
export default defaultTheme;
